export function Search({ loading, search, handleEdit, handleDelete }) {
  return (
    <div className="userList">
      {loading
        ? "Carregando..."
        : search.map((item) => {
            return (
              <div className="row list" key={item.id}>
                <div className="col-md-1 items">{item.id}</div>
                <div className="col-md-5 items">
                  <span>{item.name}</span>
                  <p style={{ fontStyle: "italic" }}>{item.email}</p>
                </div>

                <div className="col-md-5 items">
                  <span className={item.active === 1 ? `active` : `inactive`}>
                    {item.active === 1 ? "Ativo" : "Inativo"}
                  </span>
                </div>

                <div className="col-md-1 actions">
                  <button onClick={() => handleEdit(item.id)}>
                    <i className="fas fa-ellipsis-v"></i>
                  </button>
                  {item.active === 1 ? (
                    <button onClick={() => handleDelete(item.id)}>
                      <i className="fas fa-ban"></i>
                    </button>
                  ) : (
                    <button disabled onClick={() => handleDelete(item.id)}>
                      <i className="fas fa-ban"></i>
                    </button>
                  )}
                </div>
              </div>
            );
          })}
      {loading
        ? ""
        : search <= 0 && <span>Não houve resultados para a pesquisa. :( </span>}
    </div>
  );
}
